module.exports = __webpack_public_path__ + "img/MY.1d4f3ab5.png";